import { render, staticRenderFns } from "./spklist.vue?vue&type=template&id=47ca1a19"
import script from "./spklist.vue?vue&type=script&lang=js"
export * from "./spklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports